export default function PageTitleSubtitle({
  title,
  subtitle,
  useEventTitleStyle,
  useFieldTitleStyle,
}) {
  return (
    <div>
      <p className={useFieldTitleStyle ? "field_title" : useEventTitleStyle ? 'event_detail_title' : 'page_title'}>
        {title}
      </p>
      <p
        className={
          useEventTitleStyle
            ? 'event_detail_description'
            : 'page_description lateral_padding'
        }
      >
        {subtitle}
      </p>
    </div>
  );
}
